import * as yup from 'yup';

export const BankCanadaPaymentInfoSchema = () =>
  yup.object({
    bankCanada: yup.object().when('paymentOption', {
      is: 'BANK_CANADA',
      then: yup.object({
        institutionNumber: yup
          .string()
          .required('Institution number is required')
          .matches(/^[0-9]+$/, 'Numerical values only')
          .length(3, 'Institution number must be 3 digits'),
        transitNumber: yup
          .string()
          .required('Transit number is required')
          .matches(/^[0-9]+$/, 'Numerical values only')
          .length(5, 'Transit number must be 5 digits'),
        accountNumber: yup
          .string()
          .required('Account number is required')
          .matches(/^[0-9]+$/, 'Numerical values only')
          .min(7, 'Minimum 7 digits')
          .max(12, 'Maximum 12 digits'),
        confirmAccountNumber: yup
          .string()
          .required('Confirm account number is required')
          .test(
            'account-number-match',
            'Account numbers must match',
            // eslint-disable-next-line func-names
            function (value) {
              return this.parent.accountNumber === value;
            }
          )
      })
    })
  });
